import { type Option } from '~/components/Select/Select';
import Select, { SelectField } from '~/components/Select/Select';
import options from '~/components/Select/options';

export default Select;

export { Option, SelectField, options };
